import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuditModelListPath, getReimbursementsSummaryPath } from "../../services/config";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
  reimburseLoading: false,
  reimburseSuccess: false,
  reimburseError: false,
  reimburseMessage: null,

  reimburseGetLoading: false,
  reimburseGetSuccess: false,
  reimburseGetError: false,
  reimburseGetMessage: null,
  reimburseGetData: null,
};


const user = localStorage.getItem("user_data")
  ? JSON.parse(localStorage.getItem("user_data"))
  : null;

const userId = user?.user_id;
const accountType = user?.account_type;

export const fetchReimburseData = createAsyncThunk(
  "fetchReimburseData",
  async (data) => {
    try {
      const userId = data?.userId || "";
      const params = new URLSearchParams();
      if (userId) params.set("userId", userId);
      if (data?.selectedMonth) params.set("selectedMonth", data.selectedMonth);
      const qs = params.toString() ? `?${params.toString()}` : "";
      const res = await axios.get(`${baseUrl}${getReimbursementsSummaryPath}${qs}`, config);
      return res;
    } catch (error) {
      if (!navigator.onLine) {
        return {
          response: { data: { message: "No Internet Connection Found" } },
          data: { data: null, message: "No Internet Connection Found" },
        };
      }
      return error;
    }
  }
);

export const saveUpdateReimburse = createAsyncThunk(
  "saveUpdateReimburse",
  async (body) => {
    const result = {
      data: {
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };

    const { path, data } = body;

    return await axios
        .post(`${baseUrl}${path}`, data, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (!navigator.onLine) {
            console.log(
              "You are offline. Please check your internet connection."
            );
          } else {
            console.log("An error occurred. Please try again later.");
          }
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        });
  }
);

const reimburseSlice = createSlice({
  name: " reimburse",
  initialState,

  reducers: {
    initReimburseState: (state) => {
      state.reimburseLoading = false;
      state.reimburseSuccess = false;
      state.reimburseError = false;
      state.reimburseMessage = null;

      state.reimburseGetLoading = false;
      state.reimburseGetSuccess = false;
      state.reimburseGetError = false;
      state.reimburseGetMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchReimburseData.pending, (state, action) => {
      state.reimburseGetLoading = true;
      state.reimburseGetSuccess = false;
      state.reimburseGetError = false;
      state.reimburseGetMessage = null;
      state.reimburseGetData = null;
    });
    builder.addCase(fetchReimburseData.fulfilled, (state, action) => {
      const status = action.payload.status;

      if (status == 200) {
        const body = action.payload.data || {};
        state.reimburseGetLoading = false;
        state.reimburseGetSuccess = true;
        state.reimburseGetError = false;
        state.reimburseGetMessage = body.message || null;
        state.reimburseGetData = body.data || body;
      } else {
        state.reimburseGetLoading = false;
        state.reimburseGetSuccess = false;
        state.reimburseGetError = true;
        state.reimburseGetMessage = action.payload.response.data.message;
        state.reimburseGetData = null;
      }
    });
    builder.addCase(fetchReimburseData.rejected, (state, action) => {
      state.reimburseGetLoading = false;
      state.reimburseGetSuccess = false;
      state.reimburseGetError = true;
      state.reimburseGetMessage =
        action.payload?.response?.data?.message || action.payload?.data?.message || action.error?.message || "Request failed";
      state.reimburseGetData = null;
    });

    // To create branch
    builder.addCase(saveUpdateReimburse.pending, (state, action) => {
      state.reimburseLoading = true;
      state.reimburseSuccess = false;
      state.reimburseError = false;
      state.reimburseMessage = null;
    });
    builder.addCase(saveUpdateReimburse.fulfilled, (state, action) => {
      const status = action.payload.status;
      if (status == 200 || status == 201) {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.reimburseLoading = false;
          state.reimburseSuccess = true;
          state.reimburseError = false;
          state.reimburseMessage = action.payload.data.message;
        } else {
          state.reimburseLoading = false;
          state.reimburseSuccess = false;
          state.reimburseError = true;
          state.reimburseMessage = action.payload.data.message;
        }
      } else {
        state.reimburseLoading = false;
        state.reimburseSuccess = false;
        state.reimburseError = true;
        state.reimburseMessage = action.payload.response.data.message;
      }
    });
    builder.addCase(saveUpdateReimburse.rejected, (state, action) => {
      state.reimburseLoading = false;
      state.reimburseSuccess = false;
      state.reimburseError = true;
      state.reimburseMessage =
        action.payload?.response?.data?.message || action.payload?.data?.message || action.error?.message || "Request failed";
    });
  },
});

export const { initReimburseState } = reimburseSlice.actions;

export default reimburseSlice.reducer;
